/**
 * Contato de suporte via WhatsApp. Número já usado (hardcoded) no Footer,
 * página de contato e privacidade — centralizado aqui para o fluxo de cursos
 * pagos sem página de vendas configurada ("Entrar em contato com suporte").
 */
export const WHATSAPP_SUPPORT_NUMBER = "5541999047847"

/** URL base do WhatsApp de suporte, sem mensagem pré-preenchida. */
export const WHATSAPP_SUPPORT_URL = `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}`

/**
 * Monta a URL do WhatsApp com mensagem pré-preenchida mencionando o curso.
 */
export function buildSupportWhatsappUrl(courseTitle: string): string {
  const text = `Olá! Tenho interesse no curso "${courseTitle}" e gostaria de saber como adquirir.`
  return `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}?text=${encodeURIComponent(text)}`
}

/**
 * Payment support runs on a dedicated line, separate from
 * WHATSAPP_SUPPORT_NUMBER: a failed checkout has to reach whoever can look at
 * the order, not the general inbox.
 */
export const WHATSAPP_CHECKOUT_SUPPORT_NUMBER = "5541998023537"

export interface CheckoutSupportContext {
  /** Course or product the buyer was trying to pay for. */
  item?: string
  /** Buyer name as typed in the form. */
  buyerName?: string
  /** Page the failure happened on, so support can reproduce it. */
  pageUrl?: string
  /** Payment method label, already in pt-BR. */
  method?: string
  /** Machine decline code, matched with the server logs. */
  errorCode?: string
  /** Error text the buyer actually saw, when there is no machine code. */
  detail?: string
  /** Pagar.me order id or internal order code. */
  refId?: string
}

/**
 * Builds the support WhatsApp deep link for a failed checkout. The opening
 * line is fixed so support recognizes the flow at a glance; every context
 * line is dropped when empty rather than sent as an empty label.
 */
export function buildCheckoutSupportWhatsappUrl(
  ctx: CheckoutSupportContext = {}
): string {
  const lines = [
    "Olá. Tive um problema no pagamento da mentoria e gostaria de uma ajuda, por favor.",
    "",
  ]
  if (ctx.buyerName?.trim()) lines.push(`Nome: ${ctx.buyerName.trim()}`)
  if (ctx.item?.trim()) lines.push(`Compra: ${ctx.item.trim()}`)
  if (ctx.method?.trim()) lines.push(`Forma de pagamento: ${ctx.method.trim()}`)
  if (ctx.pageUrl?.trim()) lines.push(`Vim do site: ${ctx.pageUrl.trim()}`)
  if (ctx.errorCode?.trim())
    lines.push(`Código do erro: ${ctx.errorCode.trim()}`)
  if (ctx.detail?.trim()) lines.push(`Mensagem: ${ctx.detail.trim()}`)
  if (ctx.refId?.trim()) lines.push(`Ref.: ${ctx.refId.trim()}`)

  const text = lines.join("\n").trimEnd()
  return `https://wa.me/${WHATSAPP_CHECKOUT_SUPPORT_NUMBER}?text=${encodeURIComponent(text)}`
}
